import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";

const EFFECTIVE_DATE = "18. 02. 2026";

function normalizeLegalText(text) {
  return text
    .replace(/Platné od:\s*[^\n]*/gi, `Platné od: ${EFFECTIVE_DATE}`)
    .replace(/Platné a účinné od:\s*[^\n]*/gi, `Platné a účinné od: ${EFFECTIVE_DATE}`)
    .replace(/Tyto Zásady používání souborů cookies jsou platné od\s*[^\n]*/gi, `Tyto Zásady používání souborů cookies jsou platné od ${EFFECTIVE_DATE}`);
}

function LegalPage({ title, fileUrl }) {
  const [content, setContent] = useState("");

  useEffect(() => {
    let isMounted = true;

    async function loadLegalText() {
      try {
        const response = await fetch(fileUrl);
        const text = await response.text();

        if (isMounted) {
          setContent(normalizeLegalText(text));
        }
      } catch (error) {
        if (isMounted) {
          setContent("Nepodařilo se načíst obsah této stránky.");
        }
      }
    }

    loadLegalText();

    return () => {
      isMounted = false;
    };
  }, [fileUrl]);

  const legalLinks = useMemo(() => ([
    { to: "/vop", label: "VOP" },
    { to: "/gdpr", label: "GDPR" },
    { to: "/cookies", label: "Cookies" },
  ]), []);

  return (
    <main className="legal-page">
      <div className="legal-page__content">
        <h1>{title}</h1>
        <p className="legal-page__effective-date">Začátek platnosti: {EFFECTIVE_DATE}</p>
        <pre className="legal-page__text">{content}</pre>
        <nav className="legal-page__nav" aria-label="Právní dokumenty">
          {legalLinks.map((link) => (
            <Link key={link.to} to={link.to} className="legal-page__link">
              {link.label}
            </Link>
          ))}
        </nav>
      </div>
    </main>
  );
}

export default LegalPage;
